var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking-success"},[_c('img',{attrs:{"src":require("@/assets/images/booking/submit.png"),"alt":""}}),_c('p',[_vm._v(" 提交成功 ")]),_c('div',{staticClass:"booking-success-back",on:{"click":_vm.goBack}},[_vm._v(" 返回首页 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }